<div #bar class="select-search">
    <mat-icon class="material-icons-outlined select-search-icon">search</mat-icon>
    <input
        #input
        class="select-search-input"
        type="text"
        autocomplete="off"
        placeholder="{{ 'Search' | translate: {Default: 'Search'} }}"
        [attr.aria-label]="'Search' | translate: {Default: 'Search'}"
        [value]="search.term"
        (input)="onInput($any($event.target).value)"
        (keydown)="onKeydown($event)"
    >
    <mat-icon *ngIf="search.term" class="material-icons-outlined select-search-clear" (click)="clear()">close</mat-icon>
</div>
<div class="select-search-empty" *ngIf="search.noMatches">
    {{ 'NoMatchesFound' | translate: {Default: "No matches found"} }}
</div>
